import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import BonusInfo from '@/data/models/domain/BonusInfo'
import type { BonusInfoResponse } from '@/data/repositories/domain/types'

@injectable()
@injectFromBase()
@RepoSettings<Endpoint>({
  model: BonusInfo,
})
export default class BonusInfoRepository extends OrmApiRepository<BonusInfo> {
  private id = '1'

  public async fillBonusInfo() {
    const path = this.endpointsService.getPath('bonusInfo')
    const response = await this.getApiSource().get<BonusInfoResponse>(path)

    await this.insertOrUpdate([
      {
        id: this.id,
        emails: response.data.email.emails,
        emailLookups: response.data.email.lookups,
        emailStatus: response.data.email.status,
      },
    ])
    return this.findBonusInfoOrFail()
  }

  public async updateBonusInfo(info: Pick<BonusInfo, 'emails' | 'emailLookups' | 'emailStatus'>) {
    await this.insertOrUpdate([
      {
        id: this.id,
        emails: info.emails,
        emailLookups: info.emailLookups,
        emailStatus: info.emailStatus,
      },
    ])
  }

  public findBonusInfoOrNull() {
    return this.findEntityByIdOrNull(this.id)
  }

  public findBonusInfoOrFail() {
    return this.findEntityByIdOrFail(this.id)
  }
}
